import React from 'react'

interface ConferenceDivisionsIconProps {
  color?: string
  size?: number
}

/**
 * Conference & Divisions icon for competition setup wizard
 */
const ConferenceDivisionsIcon: React.FC<ConferenceDivisionsIconProps> = ({
  color = '#F2B400',
  size = 40,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
    >
      <path
        d='M22.3332 36.6668H35.6665V25.0002H30.6665V18.3335H22.3332V15.0002H27.3332V3.3335H13.9998V15.0002H18.9998V18.3335H10.6665V25.0002H5.6665V36.6668H18.9998V25.0002H13.9998V21.6668H27.3332V25.0002H22.3332V36.6668ZM17.3332 11.6668V6.66683H23.9998V11.6668H17.3332ZM15.6665 28.3335V33.3335H8.99984V28.3335H15.6665ZM32.3332 28.3335V33.3335H25.6665V28.3335H32.3332Z'
        fill={color}
      />
    </svg>
  )
}

export default ConferenceDivisionsIcon
